/**
 * Distribution chart. Filled area line(s): one trace per `series[]`, or a single
 * trace from `encoding.yKey`.
 */

import type { ChartTypeDefinition, ChartTrace } from '../types';
import { registerChart } from '../registry';
import { makeSeriesTraces } from '../shared/traces';
import { xColumn } from '../shared/encoding';
import { colorAt } from '../theme/palette';

export const distributionChart: ChartTypeDefinition = {
  id: 'distribution',
  label: 'Distribution',
  capabilities: {
    multiSeries: true,
    supportsXKey: true,
    supportsYKey: true,
    supportsGroupBy: false,
    supportsLimits: true,
    filterable: true,
    supportsStacked: false,
    legendByDefault: false,
    supportsLineStyle: true,
  },
  buildTraces(model, ctx) {
    const { data, encoding, series, labels } = model;

    if (series.length > 0) {
      return makeSeriesTraces(
        data,
        xColumn(data, encoding.xKey),
        series,
        ctx.palette,
        'distribution'
      );
    }
    if (encoding.yKey) {
      const trace: ChartTrace = {
        x: xColumn(data, encoding.xKey),
        y: data.map((d) => d[encoding.yKey as string]),
        name: labels.title ?? 'value',
        type: 'scatter',
        mode: 'lines',
        fill: 'tozeroy',
        line: { color: colorAt(0, ctx.palette) },
      };
      return [trace];
    }
    return [];
  },
};

registerChart(distributionChart);
